import { render } from "./Team_post_investment_operation_bar.vue?vue&type=template&id=dcd67bb6&scoped=true"
import script from "./Team_post_investment_operation_bar.vue?vue&type=script&lang=js"
export * from "./Team_post_investment_operation_bar.vue?vue&type=script&lang=js"

import "./Team_post_investment_operation_bar.vue?vue&type=style&index=0&id=dcd67bb6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dcd67bb6"

export default script